export default __webpack_public_path__ + "static/media/3IBM.e685991d.svg";